import { createContext, useState, useEffect } from 'react';
import { AutoNIDefault } from "./Data";

const param: IProviderAutoNI = {} as IProviderAutoNI;

const DataContext = createContext(param);

const DataProvier = ({ children }: any) => {
    const [AutoNI, setAutoNI] = useState({ ...AutoNIDefault });

    useEffect(() => {
        setAutoNI({
            ...AutoNI,
            init: true
        });
    }, [AutoNI.init]);

    const changeHandler = (event: any) => {
        setAutoNI({ ...AutoNI, [event.target.name]: event.target.value });
    }

    return (
        <DataContext.Provider value={{ AutoNI, setAutoNI, changeHandler }}>
            {children}
        </DataContext.Provider>
    );
}

export { DataContext, DataProvier }